import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, isProPlan }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 0;
    width: 100%;
    padding: 24px;
    background: #ffffff;
    border-radius: ${isProPlan ? '16px 16px 0 0' : '24px'};
    margin-top: ${isProPlan ? '0' : '-42px'};
    z-index: 1;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 20px 0;
      margin-top: ${isProPlan ? '0' : '-16px'};
      border-radius: 0;
    }
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 0 20px
    }
  `}
`;

export const DivContentHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: max-content;

    svg {
      fill: ${theme.v2.colors.brand.primaryDark};
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.brand.primaryDark};
    margin-left: 8px;
    margin-top: 0;
    margin-bottom: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const Button = styled.button`
  ${() => css`
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
  `}
`;

export const TitleButton = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.brand.primaryMedium};
    margin-left: 8px;
    margin-top: 0;
    margin-bottom: 0;
  `}
`;

export const CardsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding-left: 20px;
      overflow-x: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
  `}
`;
